var shawarma = [
    {
        "id": "37",
        "category": "shawarma",
        "name": "Suppli BBQ Chickens",
        "img": "https://i.imgur.com/6gvwxbt.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 3.99
    },
    {
        "id": "38",
        "category": "shawarma",
        "name": "Fried Chicken Americana",
        "img": "https://i.imgur.com/O0cfCQK.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 4.99
    },
    {
        "id": "39",
        "name": "Tarragol Rubble Mexicana",
        "category": "shawarma",
        "img": "https://i.imgur.com/NLxqMow.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "40",
        "name": "Roma Naga Beneta",
        "category": "shawarma",
        "img": "https://i.imgur.com/llC8cnj.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 5.99
    },
    {
        "id": "41",
        "name": "Beef Roll Glazed",
        "category": "shawarma",
        "img": "https://i.imgur.com/KVXsO1M.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "42",
        "name": "Lakasana Soi Glazed",
        "category": "shawarma",
        "img": "https://i.imgur.com/uhpgvee.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 5.99
    },


]
export default shawarma;